












import API from '@core/services/API'
import { inject } from 'inversify-props'
import { Component, Prop, Vue } from 'vue-property-decorator'
import AppDatatable from '@core/components/AppDatatable.vue'
import AppDialog from '@core/components/AppDialog.vue'
import AppForm from '@core/components/AppForm.vue'
import { ClientPolicyDto } from '../../api'

@Component({
  components: {
    AppDatatable,
    AppDialog,
    AppForm
  }
})
export default class SubmittedDocuments extends Vue {
  @Prop() policy: ClientPolicyDto

  @inject()
  private $api: API

  private existingDocuments: Array<{
    fileName: string;
    fileUrl: string;
    fileType: string;
  }> = []

  get policyOid () {
    return this.$route.query.policy_oid
  }

  get isDisabled () {
    return this.$store.getters.currentUser.systemrole !== 'ops-staff'
  }

  get existingDocumentsColumns (): Array<{ label: string; field: string }> {
    return [
      { label: 'File Name', field: 'fileName' },
      { label: 'File Type', field: 'fileType' }
    ]
  }

  get existingDocumentsData () {
    return this.existingDocuments.map(e => {
      return {
        ...e,
        emit: true
      }
    })
  }

  downloadDocument (documentOid, fileName) {
    const link = `/live/getPolicyDocument?fileType=submitted&documentOid=${documentOid}&fileName=${fileName}`
    window.open(link, '_blank')
  }

  downloadExistingDocument (file: {
    fileName: string;
    fileUrl: string;
    fileType: string;
  }) {
    const link = `/live/${file.fileUrl}`
    window.open(link, '_blank')
  }

  async fetchExistingDocuments () {
    /* eslint-disable @typescript-eslint/camelcase */
    const res = await this.$api.clientPolicy.getTaggedKycDocuments({ profile_policy_oid: this.policy.oid })
    this.existingDocuments = res.data
  }

  async mounted () {
    await this.fetchExistingDocuments()
  }
}
